import React from 'react';
import Modal from '@mui/material/Modal';
import './styles.css';
import { Button, FormControlLabel, IconButton, Radio, RadioGroup, Typography } from '@mui/material';
import { ContractSelectionProps } from '../../interfaces/props/ContractSelectionProps';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { sxButton, sxNameCard, sxNumberCard, sxRadioGroup, sxSubTitle, sxTitle } from './sxProps';
import { useAccessibility } from '../../Store/contexts/AccessibilityContext';
import { getTipoUsuario } from '../../utils/getTipoUsuario';


const ContractSelection: React.FC<ContractSelectionProps> = ({ idUsrContr, handleShowModal, listaBeneficiarios, handleSelectButton, showModal, handleRadioButton, buttonText, handleClickRadioButton }) => {

  const { textStyleAccessibility, buttonStyleAccessibility, buttonTextStyleAccessibility } = useAccessibility();

  return (
    <div>
      <Modal
        open={showModal}
        onClose={handleShowModal}
      >
        <div style={textStyleAccessibility} className='container-modal-contract ' >
          <div className='container-button-close-contract'>
            <IconButton style={buttonStyleAccessibility} aria-label='Fechar' onClick={handleShowModal}>
              <FontAwesomeIcon icon={faTimes} />
            </IconButton>
          </div>
          <Typography style={textStyleAccessibility} sx={sxTitle}>Selecione qual cartão deseja utilizar</Typography>
          <Typography style={textStyleAccessibility} sx={sxSubTitle}>Escolha qual dos cartões deseja obter mais informações e acesse.</Typography>

          <RadioGroup
            sx={sxRadioGroup}
            className='container-contracts-options'
          >
            {listaBeneficiarios?.map((beneficiario) =>
              <FormControlLabel
                key={beneficiario.idUsrContr}
                value={beneficiario.idUsrContr}
                control={
                  <Radio checked={idUsrContr === beneficiario.idUsrContr}
                    onKeyDown={(e) => handleRadioButton(beneficiario.idUsrContr, e)}
                    onClick={(e) => {
                      if (e.clientX)
                        handleClickRadioButton(beneficiario.idUsrContr)
                    }}
                    style={{ background: 'white' }} color='default'
                  />
                }
                label={
                  <div>
                    <Typography style={textStyleAccessibility} sx={sxNumberCard}>{beneficiario.codAntigoUsrDescr}</Typography>
                    <Typography style={textStyleAccessibility} sx={sxNameCard}>
                      {`${beneficiario.pessoa.nomeUsrContr} | ${getTipoUsuario(beneficiario.codTipoUsr)} - ${beneficiario.contrato.codStatusUsrContr}`}
                    </Typography>
                  </div>
                } />
            )}
          </RadioGroup>
          <div className='container-button-avancar-contract'>
            <Button disabled={idUsrContr === 0} style={buttonStyleAccessibility} variant='contained' onClick={handleSelectButton} sx={sxButton}>
              <Typography style={buttonTextStyleAccessibility}>{buttonText}</Typography>
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ContractSelection;
